import React, { useContext, useRef, useState } from 'react'
import 'stylesheets/TimerAppStyles/Modal.css'
import { TodoContext } from 'contexts/TimerAppContexts/TodoContext';
import { motion } from "framer-motion"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons'

const TodoForm = () => {

    const { setOpenModal, addTodo } = useContext(TodoContext)

    const [todoName, setTodoName] = useState('');
    const [todoCategory, setTodoCategory] = useState('Gym');
    const [todoIntensity, setTodoIntensity] = useState(0);
    const [emptyName, setEmptyName] = useState(false);
    const [pomoCount, setPomoCount] = useState(1);

    const [completedPomodoros] = useState(0);
    const inputRef = useRef(null)

    const onSubmit = (e) => {
        e.preventDefault()
        let newTodoIntesity;
        if (todoIntensity === 0) {
            newTodoIntesity = 'easy'
        } else if (todoIntensity === 1) {
            newTodoIntesity = 'medium'
        } else {
            newTodoIntesity = 'high'
        }
        if (todoName === '' || todoName == null || todoName.replace(/\s/g, "") === '') {
            setEmptyName(true)
            inputRef.current.focus()
        } else {
            addTodo(todoName, todoCategory, newTodoIntesity, pomoCount, completedPomodoros)
            setOpenModal(false)
        }
    }

    const onCancel = (e) => {
        e.preventDefault()
        setOpenModal(false)
    }

    const handleNameChange = (e) => {
        if (e.target.value === '' || e.target.value == null) {
            setEmptyName(true)
        } else {
            setEmptyName(false)
        }
        setTodoName(e.target.value)
    }

    const handleCategoryChange = (e) => {
        setTodoCategory(e.target.value)
    }

    const handleIntesityChange = (e) => {
        setTodoIntensity(Number(e.target.value))
    }

    const incrementPomCount = (e) => {
        if (pomoCount < 10) {
            setPomoCount(pomoCount + 1)
        }
    }
    const decrementPomCount = (e) => {
        if (pomoCount > 1) {
            setPomoCount(pomoCount - 1)
        }
    }
    const handlePomoInput = (e) => {
        const value = parseInt(e.target.value);
        if (!isNaN(value) && value >= 1 && value <= 10) {
            setPomoCount(value);
        }
    }


    return (
        <motion.form onSubmit={onSubmit} className='add-modal'
            initial={{
                scale: 0
            }}
            animate={{
                scale: 1
            }}
        >
            <h1>Add Todo</h1>
            <p className="subtitle">To-do</p>
            {emptyName && <p className='error_name'>* Name is Required</p>}
            <input
                ref={inputRef}
                placeholder='What needs to be done?'
                className='todo-input-name'
                value={todoName}
                onChange={handleNameChange}
            />
            <p className="subtitle">Category</p>
            <select onChange={handleCategoryChange} name="category" id="category-select" className='todo-input-category'>
                <option value="Gym">Gym</option>
                <option value="Home">Home</option>
                <option value="Programming">Programming</option>
                <option value="School">School</option>
                <option value="Work">Work</option>
                <option value="Chores">Chores</option>
                <option value="Others">Others</option>
            </select>
            <p className="subtitle">Difficulty</p>
            <div className='range-container'>
                <input
                    className='todo-input-range'
                    type="range"
                    min="0"
                    max="2"
                    step="1"
                    value={todoIntensity}
                    onChange={handleIntesityChange}
                />
                <div className='spans-container'>
                    <span>Easy</span>
                    <span>Medium</span>
                    <span>Hard</span>
                </div>
            </div>
            <p className="subtitle">Pomodoros</p>
            <div className='add-todo-count'>
                <button type='button' className='controllers' onClick={decrementPomCount}><FontAwesomeIcon className='icon-btn' icon={faMinus}/></button>
                <input className='number-input' type="number" onChange={handlePomoInput} value={pomoCount} min={1} max={10} />
                <button type='button' className='controllers' onClick={incrementPomCount}><FontAwesomeIcon className='icon-btn' icon={faPlus}/></button>
            </div>
            <div className='btn-container'>
                <button className='add-modal-btn add-modal-btn--cancel' type='button' onClick={onCancel}>Cancel</button>
                <button className='add-modal-btn add-modal-btn--add' type='submit'>Create</button>
            </div>
        </motion.form>
    )
}

export { TodoForm }